/**
 * HomeARDemoCrmContentView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait HomeARDemoCrmContent
 */

import { useHomeARDemoCrmContentLogic } from '@/hooks/traits/useHomeARDemoCrmContentLogic';
import type { HomeARDemoCrmContentConfig } from '@/hooks/traits/useHomeARDemoCrmContentLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { HomeARDemoCrmDeal } from '@app/shared';
import { HomeARDemoCrmStageChartView } from '@/components/traits/HomeARDemoCrmStageChartView';
import { Typography } from '@almadar/ui/components';
import { Split } from '@almadar/ui/components';
import { Card } from '@almadar/ui/components';
import { HomeARDemoCrmBoardView } from '@/components/traits/HomeARDemoCrmBoardView';
import { Stack } from '@almadar/ui/components';
import { HomeARDemoCrmStatsView } from '@/components/traits/HomeARDemoCrmStatsView';
import { UISlotComponent, renderPatternValue } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';
import { useTranslate } from '@almadar/ui/hooks';

interface HomeARDemoCrmContentViewProps {
  config?: Partial<HomeARDemoCrmContentConfig>;
}

export function HomeARDemoCrmContentView({ config: propsConfig }: HomeARDemoCrmContentViewProps) {
  const { t: __t, locale: __locale } = useTranslate();
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useHomeARDemoCrmContentLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['HomeARDemoCrmDeal'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="HomeAR" trait="HomeARDemoCrmContent">
      {slotWriter['main'] === 'INIT' ? (<Stack gap="md" className="p-5" direction="vertical"><Stack direction="vertical" gap="none"><Typography content={renderPatternValue(__t("std-almadar-demo-crm-page:page.title"))} variant="h3" /><Typography color="muted" content={renderPatternValue(__t("std-almadar-demo-crm-page:page.subtitle"))} variant="small" /></Stack><Split gap="md" ratio="4:1"><HomeARDemoCrmBoardView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Stack gap="md" direction="vertical"><HomeARDemoCrmStatsView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Card padding="sm"><HomeARDemoCrmStageChartView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Card></Stack></Split></Stack>) : null}
    </TraitScopeProvider>
  );
}

export default HomeARDemoCrmContentView;
